

export const ColorAvailable = "#009900";
export const ColorWaiting = "#FF9900";
export const ColorUnAvailable = "#990000";

export const PrimaryColor = "#2B7092";

export const PrimaryBackgroundColor = "#F4F8F9";

export const ActiveColor = "#CCDCE4";
export const InactiveColor = "#d5e2e9";


// WEBPACK FOOTER //
// ./src/components/global.style.ts